// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2M52L","insightsList":"newBusinessInsightsMenu_insightsList__3_MQa","active":"newBusinessInsightsMenu_active__9PjKA"};